import React from "react";

import {
  ArrowBackIosNewRounded,
  EditRounded,
  SaveRounded,
  StorefrontRounded,
  WarningRounded,
} from "@mui/icons-material";
import { Alert, Box, ButtonBase } from "@mui/material";
import { useNavigate } from "react-router-dom";

import useModal from "../../../config/context/modalContext";
import { GreyPallet } from "../../../config/styles";
import useCafeteria from "../context";

import IMask from "imask/holder";
import ChipMain from "../../../components/InputMain/ChipMain";
import SwitchMain from "../../../components/InputMain/SwitchMain";
import TextMain from "../../../components/InputMain/TextMain";
import MainSolidButton from "../../../components/MainSolidButton";
import MainText from "../../../components/MainText";
import PageHeader from "../../../components/PageHeader";
import { Constants } from "../../../config/constants";
import ModalWriteCafeteria from "../components/ModalWriteCafeteria";

export default function SettingsTab() {
  const navigate = useNavigate();

  let phoneMask = IMask.createMask({ mask: "(00) 0 0000-0000" });

  const { showImage } = useModal();
  const { currentCafeteria, handleGetCafeterias } = useCafeteria();

  const [showModalEdit, setShowModalEdit] = React.useState(false);
  const [showModalCreate, setShowModalCreate] = React.useState(false);

  phoneMask.resolve(currentCafeteria?.phone || "");

  const [locIdField, setLocIdField] = React.useState<string[]>([]);

  const onCloseModalHandler = (reload?: boolean) => {
    setShowModalCreate(false);
    setShowModalEdit(false);

    if (reload) handleGetCafeterias();
  };

  return (
    <Box>
      <PageHeader
        title="Configurações"
        leftIcon={<ArrowBackIosNewRounded />}
        onLeftAction={() => navigate("/cafeteria")}
      />

      {!currentCafeteria?.enabled ? (
        <Alert icon={<WarningRounded fontSize="inherit" />} severity="warning" sx={{ mb: 2 }}>
          Aguardando liberação
        </Alert>
      ) : null}

      {showModalEdit && currentCafeteria && (
        <ModalWriteCafeteria cafeteria={currentCafeteria} onClose={onCloseModalHandler} />
      )}

      <Box
        sx={{
          width: "100%",
          alignItems: "center",
          backgroundColor: GreyPallet.Light,
          borderRadius: "15px",
          p: 2,
          mb: 2,
          boxSizing: "border-box",
        }}
      >
        <ButtonBase
          onClick={() => !!currentCafeteria?.image && showImage(currentCafeteria.image.resource)}
          sx={{
            width: "100%",
            height: "100px",
            backgroundColor: GreyPallet.LightGhost,
            borderRadius: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: GreyPallet.Regular,
            overflow: "hidden",
            mb: 1,
          }}
        >
          {currentCafeteria?.image ? (
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={currentCafeteria.image.resource}
            />
          ) : (
            <StorefrontRounded sx={{ width: "32px", height: "32px" }} />
          )}
        </ButtonBase>

        <Box sx={{ display: "flex", flexDirection: "column" }} gap={1} mb={2}>
          <MainText>{currentCafeteria?.name}</MainText>
          <MainText color="regular" size="caption">
            {currentCafeteria?.description}
          </MainText>
          <MainText>{phoneMask.value}</MainText>
          <MainText>/{currentCafeteria?.site}</MainText>
          <MainText>@{currentCafeteria?.instagram}</MainText>
          <MainText>{currentCafeteria?.locationText}</MainText>
        </Box>

        <MainSolidButton
          text="Editar Informações"
          icon={<EditRounded />}
          onClick={() => setShowModalEdit(true)}
        />
      </Box>

      {/* Delivery */}

      <Box mb={1} mt={4}>
        <MainText size="body" color="black">
          Tipos de Entrega Disponíveis
        </MainText>
      </Box>

      <SwitchMain
        loading={false}
        name={"Retirada em Lugar Predefinido"}
        small={"Defina abaixo os pontos de entrega que os clientes podem pegar o pedido."}
        checked={false}
        onChange={(checked) => {}}
      />

      <Box mb={1}>
        <MainText size="small" color="regular">
          No momento só serão possíveis pontos de entrega definidos dentro do campus da UFRN.
        </MainText>
      </Box>

      <Box display={"flex"} gap={1} flexWrap={"wrap"} mb={2}>
        <ChipMain
          options={Constants.cafeteriaSpots}
          onChange={(value: any) => {
            if (locIdField.includes(value))
              setLocIdField(locIdField.filter((item) => item !== value));
            else setLocIdField([...locIdField, value]);
          }}
          value={locIdField}
          multiple
        />
      </Box>

      <SwitchMain
        loading={false}
        name={"Retirada no Restaurante"}
        small={
          "Os cliente retiram o produto diretamente no restaurante. Mantenha o seu endereço atualizado."
        }
        checked={false}
        onChange={(checked) => {}}
      />

      <SwitchMain
        loading={false}
        name={"Delivery"}
        small={"Os clientes podem inserir um endereço para a entrega."}
        checked={false}
        onChange={(checked) => {}}
      />

      <Box mb={1}>
        <MainText size="small" color="regular">
          Vôce pode desativar todos os tipos de entrega, dessa forma os pedidos ainda serão criados,
          mas sem nenhuma forma de entrega disponível para os cliente.
        </MainText>
      </Box>

      {/* Payment */}

      <Box mb={1} mt={4}>
        <MainText size="body" color="black">
          Tipos de Pagamento Disponíveis
        </MainText>
      </Box>

      <SwitchMain
        loading={false}
        name={"PIX via App"}
        small={
          "Habilita os pagamentos via PIX diretamente no aplicativo. Esses pagamentos ficam retidos até o fim do dia quando são tranferidos para o seu PIX de preferência."
        }
        checked={false}
        onChange={(checked) => {}}
      />

      <TextMain name="Chave Pix" value={""} onChange={() => {}} textColor={"regular"} />
      <TextMain name="Nome do Titular" value={""} onChange={() => {}} textColor={"regular"} />

      <SwitchMain
        loading={false}
        name={"PIX na Entrega"}
        checked={false}
        onChange={(checked) => {}}
      />

      <SwitchMain
        loading={false}
        name={"Crédito na Entrega"}
        checked={false}
        onChange={(checked) => {}}
      />

      <SwitchMain
        loading={false}
        name={"Débito na Entrega"}
        checked={false}
        onChange={(checked) => {}}
      />

      {/* Order */}

      <Box mb={1} mt={4}>
        <MainText size="body" color="black">
          Configurar Pedidos
        </MainText>
      </Box>

      <SwitchMain
        loading={false}
        name={"Envio Obrigatório via WhatsApp"}
        small={"Informa ao usuário que o pedido só será processado se for enviado para o WhatsApp"}
        checked={false}
        onChange={(checked) => {}}
      />

      <MainSolidButton
        text="Salvar"
        icon={<SaveRounded />}
        onClick={() => setShowModalEdit(true)}
      />
    </Box>
  );
}
